// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"224":"df4818d1","3110":"93e768b3","6366":"3e154e90","8655":"c9df34ad"}[chunkId] + ".chunk.css";
};